var _linearGradient, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1037.6 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr-online-store--lg-1",
    x1: 348.5889,
    x2: 518.9966,
    y1: 505.3004,
    y2: -32.1391,
    gradientTransform: "matrix(1 0 0 -1 0 1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9787,
    stopColor: "#098aed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hr-online-store--lg-1)",
    d: "M319.6 535.1L1.7 591.2C5 609.7 13 627.3 25.4 642.1l267.8 319.1c24.9 29.7 63.8 43.9 102 37.1L805.4 926c19.1-3.4 36.6-11.7 50.9-23.7L648.8 655c-80.4-95.9-205.9-141.6-329.2-119.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41d3bd",
    d: "M1012.2 357.9L744.4 38.8C732 23.9 716 13 698.4 6.5L588 309.9c-42.8 117.6-19.6 249.1 60.8 345l207.6 247.4c14.4-12 25.6-27.8 32.2-46L1031 464.8c13.3-36.4 6.1-77.2-18.8-106.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#098aed",
    d: "M698.4 6.5c-17.6-6.4-36.9-8.3-56-4.9L232.2 74c-38.2 6.7-69.9 33.3-83.1 69.8L6.5 535.2c-6.6 18.2-8.2 37.5-4.9 56l318-56.1C442.9 513.4 545.2 427.5 588 309.9L698.4 6.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineStore);
export default __webpack_public_path__ + "static/media/online-store.d1b96553.svg";
export { ForwardRef as ReactComponent };